import { Injectable, signal } from '@angular/core';

export type SelectPortalContainerId = symbol;

interface SelectPortalContainerEntry {
  id: SelectPortalContainerId;
  element: HTMLElement;
}

/**
 * Stack registry for ng-primitives select/dropdown portal targets.
 * Used by nested overlays (e.g. calendar input) so dropdown panels render
 * inside the parent overlay instead of document.body.
 */
@Injectable({
  providedIn: 'root',
})
export class SelectPortalContainerService {
  private readonly stack: SelectPortalContainerEntry[] = [];

  /** Current portal container for dropdowns (top of stack). */
  readonly currentContainer = signal<HTMLElement | null>(null);

  register(element: HTMLElement): SelectPortalContainerId {
    const id = Symbol('select-portal-container');
    this.stack.push({ id, element });
    this.currentContainer.set(element);
    return id;
  }

  unregister(id: SelectPortalContainerId): void {
    const index = this.stack.findIndex((entry) => entry.id === id);
    if (index === -1) {
      return;
    }
    this.stack.splice(index, 1);
    const top = this.stack.at(-1);
    this.currentContainer.set(top?.element ?? null);
  }
}
